import { IDonorConnectIldaUploadedFile } from "@nkr/models/index";
import { Button, Modal } from "react-bootstrap";
import { TableWrapperLeftAligned } from "./styles";
import * as moment from 'moment';

interface IProps {
    show: boolean
    files: IDonorConnectIldaUploadedFile[],
    onClose: () => void
}

const Files = (props: IProps) => {
    return (
        <Modal show={props.show} bsSize="large" backdrop='static' onHide={props.onClose} style={{ zIndex: 99999999 }}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Uploaded ILDA Files
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TableWrapperLeftAligned className='table table-condensed table-striped table-bordered'>
                    <thead>
                        <tr>
                            <th className='value-column'>File Name</th>
                            <th className='value-column'>File Description</th>
                            <th className='value-column'>Upload Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {props.files.map((file, index) =>
                            <tr key={index}>
                                <td className='value-column'>{file.filePath}</td>
                                <td className='value-column'>{file.description}</td>
                                <td className='value-column'>{moment(file.uploadDateTime).format("YYYY-MM-DD")}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapperLeftAligned>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default Files;